<app-loading-panel [isLoading]="isLoading"></app-loading-panel>
<div *ngIf="content">

    <ngx-extended-pdf-viewer [src]="content" [useBrowserLocale]="true" [textLayer]="true" [showHandToolButton]="true"
        [showToolbar]="true" [customToolbar]="signButtons" [filenameForDownload]="fileName"
        [showDrawEditor]="false"></ngx-extended-pdf-viewer>


    <ng-template #signButtons>
        <div id="toolbarViewer">
            <div id="toolbarViewerLeft">
                <pdf-toggle-sidebar></pdf-toggle-sidebar>
                <div class="toolbarButtonSpacer"></div>
                <pdf-paging-area></pdf-paging-area>
            </div>
            <pdf-zoom-toolbar></pdf-zoom-toolbar>
            <div id="toolbarViewerRight">

                <div fxLayout="row" fxLayoutGap="5">
                    <kendo-icon *ngIf="documentInfo.isSigned" size="xxlarge" [name]="'signature'" themeColor="success"
                        title="{{'claims-center.claimDocumentation.documentSigned' | translate}}"></kendo-icon>
                    <button *ngIf="!documentInfo.isSigned" kendoButton (click)="showSignatureArea()"
                        [icon]="'signature'" [primary]="true"> </button>

                    <button *ngIf="documentInfo.isSigned && !documentInfo.emailWithSignedDocumentSentTimestamp"
                        type="button" kendoButton (click)="sendSignedDocumentByEmail()" [primary]="true" icon="email">
                    </button>
                    <kendo-icon *ngIf="documentInfo.isSigned && documentInfo.emailWithSignedDocumentSentTimestamp"
                        size="xxlarge" [name]="'email'" themeColor="success"
                        title="{{'claims-center.claimDocumentation.documentSentByEmail' | translate}} {{ documentInfo.emailWithSignedDocumentSentTimestamp | date:'yyyy-MM-dd HH:mm'}}"></kendo-icon>

                    <button kendoButton (click)="goBack()" [primary]="true"> {{'global.close' | translate}} </button>
                </div>

                <pdf-open-file></pdf-open-file>
                <pdf-presentation-mode></pdf-presentation-mode>
                <pdf-print></pdf-print>
                <pdf-download></pdf-download>
                <div class="verticalToolbarSeparator hiddenSmallView"></div>
                <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
            </div>
        </div>
    </ng-template>
</div>

<div kendoDialogContainer #addCustomerSignatureDialog></div>